var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tour', {
    attrs: {
      "name": _vm.name,
      "steps": _vm.steps,
      "callbacks": _vm.tourCallbacks,
      "options": _vm.tourOptions
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (tour) {
        return [_c('transition', {
          attrs: {
            "name": "fade"
          }
        }, [tour.steps[tour.currentStep] ? _c('v-step', {
          key: tour.currentStep,
          attrs: {
            "step": tour.steps[tour.currentStep],
            "previous-step": tour.previousStep,
            "next-step": tour.nextStep,
            "stop": tour.stop,
            "skip": tour.skip,
            "is-first": tour.isFirst,
            "is-last": tour.isLast,
            "labels": tour.labels,
            "highlight": tour.highlight
          }
        }, [[_c('div', {
          staticClass: "absolute top-20 left-20 w-40 h-40 z-50",
          staticStyle: {
            "box-shadow": "0 0 0 99999px rgba(58,24,209,0.25)"
          }
        }, [_vm._v("\n            Hello\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "z-40",
          attrs: {
            "slot": "header"
          },
          slot: "header"
        }, [_c('div', {
          staticClass: "text-xl mt-2 leading-tight"
        }, [_vm._v("\n              " + _vm._s(tour.steps[tour.currentStep].header.title) + "\n            ")]), _vm._v(" "), _c('button', {
          staticClass: "rounded-full border border-pink-200 bg-pink-100 w-4 h-4 absolute right-2 top-2 flex justify-center items-center",
          on: {
            "click": tour.skip
          }
        }, [_c('icon', {
          staticClass: "text-pink-600 h-1.5 w-1.5",
          attrs: {
            "name": "close"
          }
        })], 1)]), _vm._v(" "), _c('div', {
          staticClass: "text-gray-600 text-xs font-light my-4",
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v("\n            " + _vm._s(tour.steps[tour.currentStep].content) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "z-40",
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "flex justify-center space-x-3"
        }, [tour.isFirst ? _c('action-button', {
          attrs: {
            "border-color": "border-indigo-300",
            "text-color": "text-indigo-600",
            "bg-color": "bg-indigo-100",
            "libelle": "Ignorer",
            "text-size": "text-sm",
            "is-small": true
          },
          on: {
            "clickAction": tour.skip
          }
        }) : _vm._e(), _vm._v(" "), !tour.isFirst ? _c('action-button', {
          attrs: {
            "border-color": "border-indigo-300",
            "text-color": "text-indigo-600",
            "bg-color": "bg-indigo-100",
            "libelle": "Précédent",
            "text-size": "text-sm",
            "is-small": true
          },
          on: {
            "clickAction": tour.previousStep
          }
        }) : _vm._e(), _vm._v(" "), !tour.isLast ? _c('action-button', {
          attrs: {
            "border-color": "border-transparent",
            "text-color": "text-white",
            "bg-color": "bg-indigo-600",
            "libelle": "Suivant",
            "icon": "arrow-right_1",
            "text-size": "text-sm",
            "is-small": true,
            "right": true,
            "onboarding": true
          },
          on: {
            "clickAction": tour.nextStep
          }
        }) : _vm._e(), _vm._v(" "), tour.isLast ? _c('action-button', {
          attrs: {
            "border-color": "border-transparent",
            "text-color": "text-white",
            "bg-color": "bg-indigo-600",
            "libelle": "Fermer",
            "text-size": "text-sm",
            "is-small": true,
            "right": true
          },
          on: {
            "clickAction": tour.finish
          }
        }) : _vm._e()], 1), _vm._v(" "), tour.isLast ? _c('div', {
          staticClass: "flex flex-row justify-center items-center mt-3"
        }, [_c('input', {
          staticClass: "mr-2",
          attrs: {
            "type": "checkbox",
            "id": "stop_showing_tour"
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "text-2sm font-light"
        }, [_vm._v("Ne plus afficher")])]) : _vm._e()])]], 2) : _vm._e()], 1)];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }